import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import * as _ from 'lodash';

import { EtablissementSiteForListModel } from '../../models/EtablissementSiteForListModel';
import { EtablissementApiService } from '../../web-api-services/etablissement.service';
import { AccountService } from '../../services/account.service';
import { UtilisateurAngular } from '../../models/UtilisateurAngular';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'select-site',
  templateUrl: './select-site.component.html',
  styleUrls: ['./select-site.component.css'],
})
export class SelectSiteComponent implements OnInit {
  // To detect input change
  private _selectedId: number;
  @Input()
  set selectedId(value: number) {
    if (this._selectedId != value) {
      this._selectedId = value;
      this.selectSite(this._selectedId);
    }
  }
  get selectedId(): number {
    return this._selectedId;
  }

  // To detect input change
  private _selectedEtablissementId: number;
  @Input()
  set selectedEtablissementId(value: number) {
    if (this._selectedEtablissementId != value) {
      this._selectedEtablissementId = value;
      this.selectEtablissement(this._selectedEtablissementId);
    }
  }
  get selectedEtablissementId(): number {
    return this._selectedEtablissementId;
  }

  // @Input()
  siteIsLocked: boolean; // Déterminé dynamiquement
  @Input() siteOnly: boolean = true;
  @Output() selectedIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() selectedEtablissementIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() selectedSiteChange: EventEmitter<EtablissementSiteForListModel> = new EventEmitter<EtablissementSiteForListModel>();

  sites: EtablissementSiteForListModel[] = [];
  selectedSite: EtablissementSiteForListModel;
  user: UtilisateurAngular;
  public etablissementsLoaded: boolean = false;

  constructor(
    private etablissementApiService: EtablissementApiService,
    private accountService: AccountService,
    private permissionService: PermissionService,
  ) {}

  ngOnInit() {
    this.siteIsLocked = true; // Par défaut, bloqué
    this.etablissementApiService.getEtablissementSitesAvecIndicateur().subscribe(sites => {
      // Filtre utilisateur
      this.user = this.accountService.getUtilisateurAngular();
      if (this.user) {
        if (this.permissionService.hasAdministrateurPermission() || this.user.EtablissementSiteId == null) {
          this.siteIsLocked = false;
        } else {
          // L'utilisateur n'est pas admin, on filtre
          if (this.permissionService.hasMultisitesPermission() && this.user.EtablissementId != null) {
            // Filtre au niveau de l'établissement
            sites = _.filter(sites, s => s.EtablissementId == this.user.EtablissementId);
            this.siteIsLocked = sites.length == 1;
          } else if (this.user.EtablissementSiteId != null) {
            // Filtre au niveau du site
            sites = _.filter(sites, s => s.SiteId == this.user.EtablissementSiteId);
          }
        }
      } else {
        sites = []; // On vide
      }

      // Il faut ajouter des lignes pour les établissements multi-sites
      if (!this.siteOnly) {
        let etablissementMultiSiteIds = _.map(
          _.filter(
            _.groupBy(
              _.map(sites, s => s.EtablissementId),
              s => s,
            ),
            s => s.length > 1,
          ),
          s => s[0],
        );
        _.forEach(etablissementMultiSiteIds, etablissementMultiSiteId => {
          let etablissementMultiSite = _.find(sites, s => s.EtablissementId == etablissementMultiSiteId);
          sites.splice(sites.indexOf(etablissementMultiSite), 0, { ...etablissementMultiSite, ...(<EtablissementSiteForListModel>{ SiteId: null, SiteNom: null }) });
        });
      }

      this.etablissementsLoaded = true;

      this.sites = sites;
      if (this._selectedId) {
        this.selectSite(this._selectedId);
      } else if (this._selectedEtablissementId) {
        this.selectEtablissement(this._selectedEtablissementId);
      }
    });
  }

  selectEtablissement(etablissementId: number) {
    if (etablissementId && etablissementId > 0) {
      this.selectedSite = _.find(this.sites, e => e.EtablissementId == etablissementId);
    } else {
      this.selectedSite = null;
    }
  }

  selectSite(siteId: number) {
    if (siteId && siteId > 0) {
      this.selectedSite = _.find(this.sites, e => e.SiteId == siteId);
    } else {
      this.selectedSite = null;
    }
  }

  siteChanged() {
    if (this.etablissementsLoaded && (this._selectedId != this.selectedSite?.SiteId || this._selectedEtablissementId != this.selectedSite?.EtablissementId)) {
      this._selectedId = this.selectedSite ? this.selectedSite.SiteId : null;
      this._selectedEtablissementId = this.selectedSite ? this.selectedSite.EtablissementId : null;
      this.selectedEtablissementIdChange.emit(this._selectedEtablissementId);
      this.selectedIdChange.emit(this._selectedId);
      this.selectedSiteChange.emit(this.selectedSite);
    }
  }
}
